

import { useEffect, useState } from "react";

import { Link } from "react-router-dom";
import styles from "./EventRegistration.module.css";

const API_BASE_URL = "https://atlastravelhouse.com";

const EventRegistration = () => {
    const [event, setEvent] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchEvent = async () => {
            try {
                const response = await fetch(
                    `${API_BASE_URL}/api/event-registrations/`
                );

                if (!response.ok) {
                    throw new Error("Failed to fetch event");
                }

                const data = await response.json();

                const activeEvent = data.find(
                    (item) => item.google_form_url
                );

                if (activeEvent) {
                    setEvent(activeEvent);
                }
            } catch (error) {
                console.error("Event registration error:", error);
            } finally {
                setLoading(false);
            }
        };

        fetchEvent();
    }, []);

    // Don't render anything if no active event/form is available
    if (loading || !event || !event.google_form_url) {
        return null;
    }

    const {
        event_name,
        event_date,
        venue,
        client_logo,
        banner,
        google_form_url
    } = event;

    const formatDate = (date) => {
        if (!date) return "";

        return new Date(date).toLocaleDateString("en-IN", {
            day: "numeric",
            month: "long",
            year: "numeric",
        });
    };

    return (
        <section className={styles.eventRegistration}>
            <div className={styles.container}>

                {/* Section Heading */}
                <div className={styles.sectionHeader}>
                    <span className={styles.eyebrow}>
                        EVENT REGISTRATION
                    </span>

                    <h2 className={styles.sectionTitle}>
                        Join Us for Your Next Experience
                    </h2>

                    <p className={styles.sectionDescription}>
                        Complete your guest registration for your upcoming
                        event or journey with Event by Atlas.
                    </p>
                </div>

                {/* Event Card */}
                <div className={styles.eventCard}>

                    {banner && (
                        <div className={styles.bannerWrapper}>
                            <img
                                src={banner}
                                alt={event_name}
                                className={styles.banner}
                            />
                        </div>
                    )}

                    <div className={styles.eventInfo}>

                        {client_logo && (
                            <div className={styles.clientLogoWrapper}>
                                <img
                                    src={client_logo}
                                    alt="Client"
                                    className={styles.clientLogo}
                                />
                            </div>
                        )}

                        <div className={styles.eventContent}>
                            <h3 className={styles.eventName}>
                                {event_name}
                            </h3>

                            <div className={styles.eventMeta}>
                                {event_date && (
                                    <span className={styles.metaItem}>
                                        {formatDate(event_date)}
                                    </span>
                                )}

                                {venue && (
                                    <span className={styles.metaItem}>
                                        {venue}
                                    </span>
                                )}
                            </div>
                        </div>

                        {/* {slug && (
                            <Link
                                to={`/register/${slug}`}
                                className={styles.registerButton}
                            >
                                Register Now
                                <span className={styles.buttonArrow}>
                                    →
                                </span>
                            </Link>
                        )} */}
{google_form_url && (
    <a
        href={google_form_url}
        className={styles.registerButton}
    >
        Register Now
        <span className={styles.buttonArrow}>→</span>
    </a>
)}
                    </div>
                </div>

            </div>
        </section>
    );
};

export default EventRegistration;
